import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/sedona-hiking';
import MapSection from '../components/Maps/sedona-hiking';

class SedonaHiking extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Sedona Red Rock Adventures: 3-Day Trail Guide</title>
          <meta name="description" content="3-day Sedona hiking guide: Cathedral Rock, Devil's Bridge, Courthouse Butte Loop, and Slide Rock State Park. The best red rock trails in Arizona." />
          <meta property="og:title" content="Sedona Red Rock Adventures: 3-Day Trail Guide" />
          <meta property="og:description" content="3-day Sedona hiking guide: Cathedral Rock, Devil's Bridge, Courthouse Butte Loop, and Slide Rock State Park. The best red rock trails in Arizona." />
          <meta property="og:url" content="https://exploroff.com/itineraries/sedona-hiking" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/sedona-hiking/sedona.jpg" />
          <link rel="canonical" href="https://exploroff.com/itineraries/sedona-hiking" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Sedona Red Rock Adventures: 3-Day Trail Guide",
            description: "3-day Sedona hiking guide covering Cathedral Rock, Devil's Bridge, Courthouse Butte, and Slide Rock.",
            image: ["https://exploroff.com/img/sedona-hiking/sedona.jpg"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/sedona-hiking" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Sedona Red Rock Adventures: 3-Day Trail Guide"
          category="itineraries"
          slug="sedona-hiking"
          excerpt="Cathedral Rock, Devil's Bridge, Courthouse Butte, and Slide Rock — the best of Arizona's red rock country."
          tags={['hiking', 'arizona', 'american southwest']}
          readTime={9}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Hotels in Sedona', type: 'Sedona, AZ · Uptown area', url: 'https://www.booking.com/searchresults.html?ss=Sedona%2C+Arizona' },
            { name: 'Village of Oak Creek', type: 'South Sedona · Budget-friendly', url: 'https://www.booking.com/searchresults.html?ss=Village+of+Oak+Creek%2C+Arizona' },
            { name: 'Hotels in Cottonwood', type: 'Gateway Town · 20 min away', url: 'https://www.booking.com/searchresults.html?ss=Cottonwood%2C+Arizona' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default SedonaHiking;
